import React from "react";
import ThemedModal from "../utilities/ThemedModal";
import { Modal, Spinner } from "react-bootstrap";
import { BaseModalOptions, ModalConfirmation } from "../../types/DefModalOptions";
import { ErrorMessage, ErrorMessageWrapper } from "../messages";
import { confirmable, createConfirmation } from "../../hooks/DialogMountPoint";

export type OpenViewPdfModalOptions = BaseModalOptions & {
    data: string,
    title?: string | undefined
};

export type ViewPdfModalOptions = ModalConfirmation<void> & {
    bodyProps?: any,
    data: string | null | undefined,
    error?: Error | string | null,
    handleClose?: () => void | undefined,
    headerProps?: any,
    isLoading?: boolean,
    refetch?: () => void | undefined,
    title?: string | undefined
};

const ViewPdfModal = ({
    backdrop = 'static',
    bodyProps = {},
    data,
    dialogId,
    error = null,
    handleClose = undefined,
    headerProps = {},
    isLoading = false,
    proceed,
    refetch = undefined,
    show,
    size = "xl",
    title,
    ...modalProps
} : Readonly<ViewPdfModalOptions>) => {

    const onClose = () => handleClose ? handleClose() : proceed!();

    return (
        <Modal 
            size={size} 
            show={show} 
            backdrop={backdrop} 
            onHide={onClose}
            dialogClassName="h-100 pb-5"
            contentClassName={(isLoading || error) ? "" : "h-100"}
            {...modalProps}
        >
            <ThemedModal.Header closeButton {...headerProps}>
                <Modal.Title>
                    {title ?? "View Business Sheet"}
                </Modal.Title>
            </ThemedModal.Header>
            <Modal.Body {...bodyProps}>
                {isLoading || data == null
                    ? <Spinner animation="border" className="d-flex mx-auto" />
                    : error == null
                        ? <iframe src={`data:application/pdf;base64,${data}`} height="100%" width="100%" title={title ?? "View Business Sheet"} />
                        : (
                            <ErrorMessageWrapper>
                                <ErrorMessage
                                    error={error}
                                    retryCallback={refetch} />
                            </ErrorMessageWrapper>
                        )}
            </Modal.Body>
        </Modal>
    );
};

export function openPdfViewerModal(options: OpenViewPdfModalOptions) : Promise<void> {
    return createConfirmation<ViewPdfModalOptions, void>(confirmable(ViewPdfModal))({
        ...options,
        dialogId: 'view_pdf_modal'
    });
};

export default ViewPdfModal;